import React, { useState } from 'react';
import { theme } from './theme';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ResourcesPage from './pages/ResourcesPage';
import JoinUsPage from './pages/JoinUsPage';
import AnnouncementsPage from './pages/AnnouncementsPage';
import AdminPage from './pages/AdminPage';
import GivingPage from './pages/GivingPage';
import { ChurchDataProvider } from './data/ChurchDataProvider';
import './App.css';

export default function App() {
  const [currentPage, setCurrentPage] = useState("Home");

  const renderPage = () => {
    switch (currentPage) {
      case "Home": return <HomePage key="home" setCurrentPage={setCurrentPage} />;
      case "About": return <AboutPage key="about" />;
      case "Resources": return <ResourcesPage key="resources" />;
      case "Announcements": return <AnnouncementsPage key="announcements" />;
      case "Join Us": return <JoinUsPage key="joinus" />;
      case "Giving": return <GivingPage key="giving" />;
      case "Admin": return <AdminPage key="admin" />;
      default: return <HomePage key="home-default" setCurrentPage={setCurrentPage} />;
    }
  };

  return (
    <ChurchDataProvider>
      <div style={{ minHeight: "100vh", background: theme.bg }}>
        <Navigation currentPage={currentPage} setCurrentPage={setCurrentPage} />
        {renderPage()}
        <Footer setCurrentPage={setCurrentPage} />
      </div>
    </ChurchDataProvider>
  );
}
